'use client'

import dynamic from 'next/dynamic'

function MapEmbed({ mapHtml }: { mapHtml: string }) {
  return <div dangerouslySetInnerHTML={{ __html: mapHtml }} />
}

// Dynamically import the MapEmbed component with ssr: false
const DynamicMapEmbed = dynamic(() => Promise.resolve(MapEmbed), { ssr: false })

// Export a wrapper that uses the dynamic component
export default function MapEmbedWrapper({ mapHtml }: { mapHtml: string }) {
  return <DynamicMapEmbed mapHtml={mapHtml} />
}
